module.exports = __webpack_public_path__ + "19ab73726eb7d53b956d081ebcebd4dc.woff2";